<template>
  <div class="modal fade modify-todo" :class="{'right': !popup}" id="add_massnahme" tabindex="-1" role="dialog" aria-modal="true" data-backdrop="static">
    <div class="modal-dialog" role="document">
<!--      <button type="button" class="close md-close" @click="closeWarning('#'+objectModalName.question)" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
      <div class="modal-content">

        <div class="modal-header">
          <h4 class="modal-title text-center"><span v-if="!currentTodo.id">{{ $t('new') }}</span> {{ $t('task') }}
            <a href="#" @click.prevent="setEdit(!edit)"><span class="lock"><i class="fa fa-pencil" aria-hidden="true" v-show="!edit"></i><i class="fa fa-lock" aria-hidden="true" v-show="edit"></i></span></a></h4>
          <button type="button" class="close xs-close" data-dismiss="modal" @click="closeWarning('#'+objectModalName.question)">×</button>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <form>
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label">{{ $t('description') }} <span class="text-danger">*</span></label>
                    <textarea class="form-control" name="description" v-model="currentTodo.description" :readonly="!edit"></textarea>
                    <span class="error-message text-danger" v-show="v$.currentTodo.description.$errors.length>0">{{ $t('required_field') }}</span>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label">{{ $t('origin') }}</label>
                    <select class="form-control task-select-origin" name="origin" v-model="currentTodo.origin" :readonly="!edit">
                      <option v-for="model in modelTypes" :value="model.id">{{model.text}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12">
                    <SelectGapQuestion @questionChanged="questionChanged" :objectID="currentTodo.question" v-show="edit || !currentTodo.id" component-name="selectTodoGapQuestion" :required="true" type="AI"></SelectGapQuestion>
                    <p v-show="!edit && currentTodo.id">{{currentTodo.question ? currentTodo.question.description : ''}}</p>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-6">
                    <label class="col-form-label">{{ $t('deadline') }}<span class="text-danger">*</span></label>
                    <date-picker v-model="currentTodo.due_date" :config="datetimeOptions" :readonly="!edit"></date-picker>
                    <span class="error-message text-danger" v-show="v$.currentTodo.due_date.$errors.length>0">{{ $t('required_field') }}</span>
                  </div>
                  <div class="col-md-6">
                    <label class="col-form-label">{{ $t('priority') }}<span class="text-danger">*</span></label>
                    <select class="form-control" name="priority" v-model="currentTodo.priority" :readonly="!edit">
                      <option v-for="prio in priority" :value="prio.value">{{ prio.label }}</option>
                    </select>
                    <span class="error-message text-danger" v-show="v$.currentTodo.priority.$errors.length>0">{{ $t('required_field') }}</span>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label">{{ $t('remarks') }}</label>
                    <textarea class="form-control" name="remarks" v-model="currentTodo.remarks"  :readonly="!edit"/>
                  </div>
                </div>
                <div class="form-group row" v-show="!edit">
                  <div class="col-md-6">
                    <label class="col-form-label">{{ $t('modified') }}</label>
                    <input class="form-control" type="text" readonly name="modified" v-model="currentTodo.modified" autocomplete="off">
                  </div>
                  <div class="col-md-6">
                    <label class="col-form-label">{{ $t('created_on') }}</label>
                    <input class="form-control" type="text" readonly name="added" v-model="currentTodo.added" autocomplete="off">
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-6">
                    <label class="col-form-label">{{ $t('status') }}</label>
                    <select class="form-control" name="status" v-model="currentTodo.status" :disabled="!edit">
                      <option v-for="state in status" :value="state.value">{{ state.label }}</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <label class="col-form-label">{{ $t('responsible_person') }}</label>
                    <input type="text" class="form-control" name="responsible" v-model="currentTodo.assigned_to_char" :readonly="!edit" autocomplete="off">
                  </div>
                </div>
                <!-- start Aufwand -->
                <slot name="works"></slot>
                <!-- end Aufwand -->
                <!-- start steps -->
                <slot name="steps"></slot>
                <!-- end steps -->
                <h4 v-if="!popup">Tags</h4>
                <div class="form-group row" v-if="!popup">
                  <div class="col-sm-12">
                    <input type="text" class="form-control" name="tag-name" placeholder="Tag List" v-model="currentTodo.tags" autocomplete="off">
                  </div>
                </div>

                <div class="text-center py-3" v-show="edit">
                  <button type="button" class="border-0 btn btn-primary btn-gradient-primary btn-rounded" @click.prevent="saveNewTodo" :key="btnEnableKey" :disabled="btnDisabled">
                    {{ $t('save') }}</button>&nbsp;&nbsp;
                  <button type="button" class="btn btn-secondary btn-rounded" @click="closeWarning('#'+objectModalName.task)">
                    {{ $t('canceled') }}</button>
                </div>
              </form>
            </div>
          </div>

        </div>

      </div><!-- modal-content -->
    </div><!-- modal-dialog -->
  </div><!-- modal -->
</template>

<script>
import {crmURL, service} from '@/utils/request.js';
import {todoOriginText, STATUS, PRIORITY, objectModalName, newWork} from '@/utils/enums';
import {ajaxErrorMessage, closeWarning, initSelect2, modelTypes} from "@/utils";
import {mapState, mapMutations} from 'vuex';
import datePicker from 'vue-bootstrap-datetimepicker';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import SelectGapQuestion from "@/components/component/SelectGapQuestion.vue";
export default {
  name: "TodoComponent",
  components: {SelectGapQuestion, datePicker},
  props: {
    currentTodo: {
      type: Object,
      required: true,
    },
    origin: {
      type: String,
      required: true
    },
    popup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      datetimeOptions: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
      },
      status: STATUS,
      priority: PRIORITY,
      modelTypes: modelTypes,
      objectModalName: objectModalName,
      btnEnableKey: 1,
      btnDisabled: false,
      currentWork: newWork,
      generateWork: true,
    }
  },
  validations() {
    return {
      currentTodo: {
        question: {required, $lazy: true},
        due_date: {required, $lazy: true},
        description: {required, $lazy: true},
        priority: {required, $lazy: true}
      },
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  watch:{
    currentTodo: {
      handler: function (newValue, oldVal) {
        if (!this.modalDirty) this.setModalDirty(true)
      },
      deep: true
    }
  },
  mounted() {
    $('#' + objectModalName.task).on('hidden.bs.modal', () => {
      this.setEdit(false)
    })
    $('#' + objectModalName.task).on('shown.bs.modal', () => {
      $('#' + objectModalName.task + ' .task-select-origin').val(this.origin).trigger('change')
      this.setModalDirty(false)
    })
  },
  beforeDestroy() {
    $('#' + objectModalName.task).off('hidden.bs.modal')
    $('#' + objectModalName.task).off('shown.bs.modal')
  },
  computed: {
    ...mapState({accountid: state => state.account.accountid, userName: state => state.user.username, account: state => state.account, userID: state => state.user.id, edit: state => state.app.edit,
      modalDirty: state => state.app.modalDirty, language: state => state.app.language,}),
  },
  methods: {
    ...mapMutations({setEdit: "SET_EDIT", setModalDirty: 'SET_MODALDIRTY'}),
    closeWarning,
    PRIORITY() {
      return PRIORITY
    },
    STATUS() {
      return STATUS
    },
    questionChanged(questionObject) {
      if (questionObject) {
        this.currentTodo.object_id = questionObject.id
        this.currentTodo.question = questionObject.id
      }
    },
    async saveNewTodo(e) {
      const isValid = await this.v$.currentTodo.$validate()
      if (!isValid) {
        this.$vToastify.error(this.$t('complete_missing_fields'))
        return
      }
      this.btnDisabled = true
      this.currentTodo.customer = this.account.name
      this.currentTodo.modified_by = this.userName
      const url = this.currentTodo.id == null ? 'todos/v1/save_ai_task/' : `todos/v1/update_ai_task/${this.currentTodo.id}/`
      this.currentTodo.model = this.currentTodo.origin
      if (this.currentTodo.origin === 'question' && !this.currentTodo.object_id) this.currentTodo.object_id = this.currentTodo.question
      service.request({
        url: url,
        method: 'POST',
        responseType: 'json',
        data: this.currentTodo
      }).then((response) => {
        this.setModalDirty(false)
        this.v$.$reset()
        this.btnDisabled = false
        this.$emit('todoUpdated', response.data)
        this.$vToastify.success(`${this.$t("task")} ${this.$t("saved_successfully")}`)
      }).catch(error => {
        this.btnDisabled = false
        this.$vToastify.error(ajaxErrorMessage(error))
      })
    },
  }
}
</script>

<style scoped>
  .close {
    right: 25px;
    top: 20px;
  }
</style>
